











    import { Component, Vue } from "vue-property-decorator";
    import { EventBus } from '@/utils/eventBus.js';
    import { getNewsDetail } from '@/api/news.js';

	@Component({})
	export default class Detail extends Vue {
        private newsInfo: any = {};

        private created() {
            EventBus.$emit('router.change', '/news');
            this.getNewsDetailData();
        }

        private async getNewsDetailData() {
            const { code, data, message } = await getNewsDetail({ id: this.$route.params.id });

            if (code === 0) {
                this.newsInfo = data;
            } else {
                console.log(message);
            }
        }
    }
